var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import moment from 'moment';
import { UrlHelper } from '../../../helper/UrlWrapper';
import { auth } from '../../../helper/authDecorator';
import { nameDict } from '../../../constant/authCode';
import OperationReportService from '../../../api/OperationReportService';
import GoodService from "../../../api/GoodService";
import CommonService from '../../../api/CommonService';
import PurchaseService from '../../../api/PurchaseService';
function setTreeData(treeData, id, name) {
    treeData.forEach(function (item) {
        item.id = item[id];
        item.name = item[name];
        if (item.children && item.children.length) {
            setTreeData(item.children, id, name);
        }
    });
}
var initFormData = {
    s_time: moment().subtract(7, 'days').format('YYYY-MM-DD'),
    e_time: moment().format('YYYY-MM-DD'),
    depot_ids: [],
};
var LossHeader = (function (_super) {
    __extends(LossHeader, _super);
    function LossHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.categoryData = [];
        _this.depotList = [];
        _this.listData = [];
        _this.tableHeight = 300;
        _this.currentCount = 0;
        _this.formData = __assign({}, initFormData, { keyword: '', goods_type_id: [] });
        _this.businessList = [];
        _this.pickerOptions0 = {
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            }
        };
        return _this;
    }
    LossHeader.prototype.created = function () {
        this.OperationReportService = OperationReportService.getInstance();
        this.goodService = GoodService.getInstance();
        this.commonService = CommonService.getInstance();
        this.purchaseService = PurchaseService.getInstance();
        this.getType();
        if (this.openedCodeData.isOpenMultOrg) {
            this.getOrganDepotList();
        }
        else {
            this.getDepotList();
        }
    };
    LossHeader.prototype.mounted = function () {
        this.search();
    };
    LossHeader.prototype.getType = function () {
        var _this = this;
        this.goodService.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    LossHeader.prototype.getOrganDepotList = function () {
        var _this = this;
        this.commonService.getOrganDepot().then(function (res) {
            var listData = Array.isArray(res.data.data) ? res.data.data : [];
            listData.forEach(function (item, index) {
                item.depot_id = new Date().getTime() + index;
                item.depot_name = item.organ_name;
            });
            setTreeData(listData, 'depot_id', 'depot_name');
            _this.depotList = listData;
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    LossHeader.prototype.getDepotList = function () {
        var _this = this;
        this.purchaseService.getSupplierdepotOptions().then(function (res) {
            var data = Array.isArray(res.data.data) ? res.data.data : [];
            setTreeData(data, 'depot_id', 'depot_name');
            _this.depotList = data;
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    LossHeader.prototype.search = function () {
        this.$emit('search', this.formData);
    };
    LossHeader.prototype.exportResult = function () {
        var url = "supplierclientapi/loss_analysis/export?s_time=" + this.formData.s_time
            + '&e_time=' + this.formData.e_time
            + '&goods_type_id=' + (this.formData.goods_type_id || [].join(','))
            + '&depot_ids=' + (this.formData.depot_ids || [].join(','))
            + '&keyword=' + this.formData.keyword;
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
        window._czc.push(["_trackEvent", '损耗分析', '损耗分析导出']);
    };
    LossHeader.prototype.initData = function () {
        this.formData = {
            s_time: moment().subtract(7, 'days').format('YYYY-MM-DD'),
            e_time: moment().format('YYYY-MM-DD'),
            depot_ids: [],
            keyword: '',
            goods_type_id: []
        };
    };
    LossHeader.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    LossHeader.prototype.normalizerShop = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    LossHeader = __decorate([
        auth(nameDict['经营报表'], true),
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
                openedCodeData: 'openedCodeData',
            })),
        })
    ], LossHeader);
    return LossHeader;
}(Vue));
export default LossHeader;
